import { useContext } from 'react';

import { ExpandableMenuItemLevelContext } from './expandable-menu-item-level-context';

/**
 * A context for storing the level value of the ExpandableMenuItem.
 */
export const LevelContext = ExpandableMenuItemLevelContext;

export const useLevel = (): number => useContext(LevelContext);
